import ActivityDuplicateForm from "./ActivityDuplicateForm";
import ActivityForm from "./ActivityForm";
import ApproveActivityForm from "./ApproveActivityForm";
import ActivityQuestionform from "./ActivityQuestionform";
import ActivitySpecialDuplicateForm from "./ActivitySpecialDuplicateForm";
import ActivitySpecialForm from "./ActivitySpecialForm";
import BusinessUnitForm from "./BusinessUnitForm";
import BranchForm from "./BranchForm";
import BookingForm from "./BookingForm";
import BannerForm from "./BannerForm";
import CertificateForm from "./CertificateForm";
import CertificateGenerateForm from "./CertificateGenerateForm";
import ChangeStatusForm from "./ChangeStatusForm";
import CorperateEmailSettingForm from "./CorperateEmailSettingForm";
import CorperateForm from "./CorperateForm";
import CorperateProductSetForm from "./CorperateProductSetForm";
import CustomerEditForm from "./CustomerEditeForm";
import EditSendCompanyForm from "./EditSendCompanyForm";
import EmailForm from "./EmailForm";
import EVoucherAddToCusForm from "./EVoucherAddToCusForm";
import HolidayForm from "./HolidayForm";
import LoginForm from "./LoginForm";
import LuckyDrawForm from "./LuckyDrawForm";
import ProductWarrantyForm from "./ProductWarrantyForm";
import ProductWarrantyRegisterForm from "./ProductWarrantyRegisterForm";
import ProductWarrantyStatusForm from "./ProductWarrantyStatusForm";
import ProductWarrantyStoreNameForm from "./ProductWarrantyStoreNameForm";
import NewForm from "./NewForm";
import PasswordForm from "./PasswordForm";
import PDPAForm from "./PDPAForm";
import PDPADuplicateForm from "./PDPADuplicateForm";
import PermissionForm from "./PermissionForm";
import ProductWarrantyCreateForm from "./ProductWarrantyCreateForm";
import QuestionForm from "./QuestionForm";
import QuickTestActivityForm from "./QuickTestActivityForm";
import RewardForm from "./RewardForm";
import RoomAvailabilityForm from "./RoomAvailabilityForm";
import MainTaskForm from "./MainTaskForm";
import MusicHallBookingEmailForm from "./MusicHallBookingEmailForm";
import MusicHallBookingForm from "./MusicHallBookingForm";
import MusicHallEventDateForm from "./MusicHallEventDateForm";
import MusicHallEventForm from "./MusicHallEventForm";
import MusicHallPaymentForm from "./MusicHallPaymentForm";
import MusicHallStatusForm from "./MusicHallStatusForm";
import ShortcutForm from "./ShortcutForm";
import ShowRoomForm from "./ShowRoomForm";
import UserManagementForm from "./UserManagementForm";
import SubTaskForm from "./SubTaskForm";
import SubTaskActionUpdateForm from "./SubTaskActionUpdateForm";
import ApproveActivityEditAnswerForm from "./ApproveActivityEditAnswerForm";
import MusicInstrumentForm from "./MusicInstrumentForm";
import QuestionDuplicateForm from "./QuestionDuplicateForm";

const EXPORT = {
  ActivityDuplicateForm,
  ActivityForm,
  ApproveActivityForm,
  ActivityQuestionform,
  ActivitySpecialDuplicateForm,
  ActivitySpecialForm,
  ApproveActivityEditAnswerForm,
  BookingForm,
  BranchForm,
  BusinessUnitForm,
  BannerForm,
  EditSendCompanyForm,
  EmailForm,
  EVoucherAddToCusForm,
  CertificateForm,
  CertificateGenerateForm,
  ChangeStatusForm,
  CorperateEmailSettingForm,
  CorperateForm,
  CorperateProductSetForm,
  CustomerEditForm,
  HolidayForm,
  LoginForm,
  LuckyDrawForm,
  ProductWarrantyForm,
  ProductWarrantyRegisterForm,
  ProductWarrantyStatusForm,
  ProductWarrantyStoreNameForm,
  QuestionDuplicateForm,
  QuestionForm,
  QuickTestActivityForm,
  PasswordForm,
  MainTaskForm,
  MusicHallBookingEmailForm,
  MusicHallBookingForm,
  MusicHallEventDateForm,
  MusicHallEventForm,
  MusicHallPaymentForm,
  MusicInstrumentForm,
  MusicHallStatusForm,
  NewForm,
  PDPAForm,
  PDPADuplicateForm,
  PermissionForm,
  ProductWarrantyCreateForm,
  RewardForm,
  RoomAvailabilityForm,
  ShortcutForm,
  ShowRoomForm,
  SubTaskActionUpdateForm,
  SubTaskForm,
  UserManagementForm,
};

export default EXPORT;
